// Shared scoring helpers for bets.
//
// Point values mirror the rules described in the FAQ (MobileFAQ): a correct
// match outcome is worth POINTS_OUTCOME, an exact score POINTS_EXACT, and
// knockout-stage bets are boosted by a multiplier applied on the backend.
export const POINTS_EXACT = 4;
export const POINTS_OUTCOME = 2;

// betResult mirrors the backend BetOutcome enum (Analysis/Models/Enums/BetOutcome.cs):
// 0 = wrong, 1 = correct (right outcome), 2 = perfect (exact score).
// Kept in sync with BetOutcomeIcon / ShowPoints / betFilters.
export function betOutcomeText(betResult: number): string {
  switch (betResult) {
    case 1:
      return "Right outcome";
    case 2:
      return "Perfect score";
    case 0:
      return "Missed";
    default:
      return "";
  }
}
